import React from 'react';
import { createRoot } from 'react-dom/client';
import TicketBookingPage from './components/TicketBookingPage';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ticket-booking-app');

  if (container) {
    const root = createRoot(container);

    // Get data from Django template
    const dataElement = document.getElementById('ticket-type-data');
    const ticketTypeData = dataElement ? JSON.parse(dataElement.textContent) : {};
    root.render(<TicketBookingPage ticketType={ticketTypeData}  maxQuantity={30}  />);
  }
});